import { render } from "./Equipos.vue?vue&type=template&id=1619aa8f&scoped=true"
import script from "./Equipos.vue?vue&type=script&lang=js"
export * from "./Equipos.vue?vue&type=script&lang=js"

import "./Equipos.vue?vue&type=style&index=0&id=1619aa8f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1619aa8f"]])

export default __exports__